<div class="dropdown container-fluid" [style.display]="filters.length > 0 || showResetButton ? 'block' : 'none'">
  <form [formGroup]="filterForm" style="margin: 0; padding: 0;">
    <div class="filter-row-container">
      <div class="filters-list">
        @for(item of filters; track $index){
        <div class="filter-item" [ngClass]="item?.type === 'multiselect-toggle' ? 'w-100' : ''">
          @switch (item?.type) {
          @case ('multiselect-toggle') {
          <multiselect-toggle [data]="item" [optionsMap]="options"></multiselect-toggle>
          }
          @case ('dropdown') {
          <app-global-dropdown [formControlName]="item.key" [options]="options[item.key] || []" [data]="item">
          </app-global-dropdown>
          }
          @case ('slider-range') {
          <app-mat-slider [data]="item">
          </app-mat-slider>
          }
          @case ('button') {
          <app-button [data]="item" [selectedKey]="selectedKey" (selectionChange)="onButtonSelectionChange($event)">
          </app-button>
          }
          @case ('icon') {
          <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;">download</mat-icon>
          }
          @case ('search') {
          <app-search-container [data]="item" (search)="onSearch($event, item.key)">
          </app-search-container>
          }
          }
        </div>
        }

        @if(showResetButton) {
        <div class="reset-container">
          <button type="button" (click)="resetButton()" class="reset-icon-btn" title="Reset Filters">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        }
      </div>
    </div>
  </form>
</div>